module.exports = __webpack_public_path__ + "img/ywy_2.2c037263.png";